import { render, staticRenderFns } from "./ComponentRegister.vue?vue&type=template&id=397ef824&scoped=true&lang=html"
import script from "./ComponentRegister.vue?vue&type=script&lang=js"
export * from "./ComponentRegister.vue?vue&type=script&lang=js"
import style0 from "./ComponentRegister.vue?vue&type=style&index=0&id=397ef824&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397ef824",
  null
  
)

export default component.exports